import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="applicant--message-form"
// applicants/messages のメッセージ送信フォーム（メイン入力欄・添付モーダル双方）で使う。
//
// テンプレート選択ボタン → 本文置換（applyTemplate）を担当する。
// テンプレートボタンには以下を付ける（_message_template_selector.html.erb 参照）:
//   data-action="click->applicant--message-form#applyTemplate"
//   data-applicant--message-form-template-body-param="<テンプレート本文>"
//
// 送信中は本文を空に見せる（長文が残ったままだと送信中表示が隠れてしまうため。bodyTargetが無いフォームでは何もしない）。
//
// 添付モーダルは送信に時間がかかるため、送信中は form.elements（form属性で外部リンクされた
// 添付inputや送信ボタンも含む）を一括disableし二重送信を防ぐ。
export default class extends Controller {
  static targets = ['body']

  connect() {
    this.element.addEventListener("turbo:submit-start", this.handleSubmitStart)
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.handleSubmitStart)
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  applyTemplate(event) {
    const body = event.params.templateBody
    if (!body || body.length === 0) return

    this.bodyTarget.value = body
  }

  handleSubmitStart = () => {
    if (this.hasBodyTarget) this.bodyTarget.value = ""
    this.setElementsDisabled(true)
  }

  handleSubmitEnd = (event) => {
    // 成功時はサーバーが applicant-detail-body 全体をturbo_streamで差し替え、このフォーム自体が
    // 新しいDOMに置き換わる（= disable状態も含めて丸ごと作り直される）ため、再有効化は不要
    if (!event.detail.success) this.setElementsDisabled(false)
  }

  setElementsDisabled(disabled) {
    Array.from(this.element.elements).forEach((el) => { el.disabled = disabled })
  }
}
